import api from './api';

export const getBuildBoxBootstrap = async () => {
  const response = await api.get('/catalog/product-editor/bootstrap');
  return response.data?.masterData || response.data;
};

export const getBuildBoxConfig = async (storefront) =>
  (await api.get(`/catalog/storefronts/${encodeURIComponent(storefront)}/build-box`)).data;

export const saveBuildBoxConfig = async (storefront, config) =>
  (await api.put(`/catalog/storefronts/${encodeURIComponent(storefront)}/build-box`, config)).data;
